import { Customer, SmartSendItemApiModel } from '~/lib/api/smartsend/types';

interface CountryOption {
  CountrySubdivision?: string;
  CountryIsoCode: string;
  Key?: string;
}

export function GetTopCountry(items: SmartSendItemApiModel[]): { Recipient: CountryOption; Sender: CountryOption } {
  const recipient = GroupBy(
    items.map((x) => toCounty(x.Recipient)),
    'Key'
  )
    .map((r) => {
      return { key: r.key, count: r.length, item: r.items[0] };
    })
    .sort((a, b) => b.count - a.count);

  const sender = GroupBy(
    items.map((x) => toCounty(x.Sender)),
    'Key'
  )
    .map((r) => {
      return { key: r.key, count: r.length, item: r.items[0] };
    })
    .sort((a, b) => b.count - a.count);

  return { Recipient: recipient[0]?.item, Sender: sender[0]?.item };
}

function toCounty(c: Customer): CountryOption {
  return {
    CountryIsoCode: c.CountryIsoCode,
    CountrySubdivision: c.CountrySubdivision,
    Key: c.CountrySubdivision ? `${c.CountryIsoCode}_${c.CountrySubdivision}` : c.CountryIsoCode
  };
}

export function GroupBy(xs, key) {
  const o = xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
  const group = [];
  for (const i in o) {
    group.push({ key: i, items: o[i], length: o[i].length });
  }
  return group.sort((x, y) => x.length - y.length);
}
